var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLineup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 340,
    height: 340,
    viewBox: "0 0 340 340",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lineup",
    transform: "translate(-152 -1010)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    transform: "translate(152 1010)",
    fill: "none",
    stroke: "#f0c807",
    strokeWidth: 20
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 170,
    r: 170,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 170,
    r: 160,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun-band-3605551",
    transform: "translate(149.529 1073.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M121.063,78.365H103.4A1.963,1.963,0,0,1,101.44,76.4c0-6.731-5.444-10.949-5.494-10.989a1.961,1.961,0,0,1-.691-2.15l11.773-37.675a23.729,23.729,0,0,1,4.254-7.712,15.341,15.341,0,0,1,16-5.357,13.907,13.907,0,0,1,9.528,8.1h0a15.411,15.411,0,0,1-.447,13.708c-2.527,4.522-6.24,7.672-10.455,8.873-.577.177-2.488.911-2.025,2.723.992,3.877,3.233,16.977,3.332,17.534h0a1.96,1.96,0,0,1-.584,1.753c-.137.133-3.591,3.606-3.591,11.189a1.962,1.962,0,0,1-1.982,1.962Zm-15.7-1.962-.114-1.962H119.17a20.258,20.258,0,0,1,4-11.239c-.538-3.1-2.3-13.151-3.109-16.3-1.068-4.171,2.257-6.754,4.748-7.456,4.317-1.232,6.938-4.921,8.108-7.014h0a11.474,11.474,0,0,0,.306-10.2,10.058,10.058,0,0,0-6.817-5.887c-11.628-2.653-15.474,9.855-15.635,10.389L99.4,63.225a18.929,18.929,0,0,1,5.856,11.216Z",
    transform: "translate(-12.628 -0.954)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M132.153,315.45H114.614a1.963,1.963,0,0,1-1.962-1.962V187.9a1.962,1.962,0,0,1,3.925,0V311.525H130.19V187.9a1.962,1.962,0,1,1,3.925,0V313.488a1.962,1.962,0,0,1-1.962,1.962Z",
    transform: "translate(-23.84 -112.456)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M267.565,361.033H249.9a1.963,1.963,0,0,1-1.962-1.962V258.995a1.962,1.962,0,1,1,3.925,0v98.113H265.6V258.995a1.962,1.962,0,0,1,3.925,0V359.07a1.962,1.962,0,0,1-1.962,1.962Z",
    transform: "translate(-110.587 -158.038)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M248.916,148.725H230.863a1.963,1.963,0,0,1-1.962-1.962c0-5.66-8.429-7.114-8.516-7.131a1.963,1.963,0,0,1-1.57-2.475L232.736,88.8a1.962,1.962,0,0,1,2.167-1.4c12.249,1.777,15.922-4.156,16.09-4.411a1.94,1.94,0,0,1,2.126-.946,1.962,1.962,0,0,1,1.526,1.779l4.129,53.721a1.961,1.961,0,0,1-1.4,2.032c-5.464,1.624-6.484,7.264-6.523,7.5h0a1.963,1.963,0,0,1-1.94,1.644Zm-16.3-3.925h14.773a13.6,13.6,0,0,1,7.343-8.433l-3.693-48.016c-2.771,1.962-7.492,3.881-15,3.14l-12.888,44.794a20.086,20.086,0,0,1,3.532,1.441c3.3,1.742,5.322,4.163,5.934,7.075Z",
    transform: "translate(-91.862 -45.806)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M579.035,282.686h-.549a8.091,8.091,0,0,1-5.934-2.276,9.733,9.733,0,0,1-2.523-6.5V197.828l3.8-43a14,14,0,0,1-3.434-9c0-6.327,4.2-10.243,8.093-10.243h.538a7.454,7.454,0,0,1,5.679,2.952h0a11.541,11.541,0,0,1,2.405,7.292,13.953,13.953,0,0,1-3.41,9l3.826,42.978v76.13a9.78,9.78,0,0,1-2.555,6.475,8.026,8.026,0,0,1-5.933,2.272Zm-5.082-84.618v75.87c0,.813.227,4.823,4.533,4.823h.549c4.317,0,4.561-4.018,4.568-4.827V198.067l-3.9-43.768h0a1.962,1.962,0,0,1,.632-1.624,10.136,10.136,0,0,0,2.845-6.833,7.615,7.615,0,0,0-1.526-4.816,3.635,3.635,0,0,0-2.634-1.5h-.538c-1.746,0-4.168,2.2-4.168,6.318h0a10.16,10.16,0,0,0,2.865,6.853,1.964,1.964,0,0,1,.632,1.62Z",
    transform: "translate(-317.105 -80.168)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M510.135,282.686h-.549a8.091,8.091,0,0,1-5.934-2.276,9.732,9.732,0,0,1-2.523-6.5V197.828l3.8-43a14,14,0,0,1-3.434-9c0-6.327,4.2-10.243,8.093-10.243h.538a7.454,7.454,0,0,1,5.679,2.952h0a11.541,11.541,0,0,1,2.405,7.292,13.954,13.954,0,0,1-3.41,9l3.826,42.978v76.13a9.781,9.781,0,0,1-2.555,6.475,8.026,8.026,0,0,1-5.933,2.272Zm-5.082-84.618v75.87c0,.813.227,4.823,4.533,4.823h.549c4.317,0,4.561-4.018,4.568-4.827V198.067l-3.9-43.768h0a1.962,1.962,0,0,1,.632-1.624,10.136,10.136,0,0,0,2.845-6.833,7.615,7.615,0,0,0-1.526-4.816,3.635,3.635,0,0,0-2.634-1.5h-.538c-1.746,0-4.168,2.2-4.168,6.318h0a10.16,10.16,0,0,0,2.865,6.853,1.964,1.964,0,0,1,.632,1.62Z",
    transform: "translate(-272.927 -80.168)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M273.445,123.248a2.1,2.1,0,0,1-.527-.071,1.962,1.962,0,0,1-1.369-2.414l.094-.342h0a1.963,1.963,0,1,1,3.784,1.04l-.107.325a1.963,1.963,0,0,1-1.875,1.46Z",
    transform: "translate(-125.678 -69.493)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M268.632,143.316a2,2,0,0,1-.523-.07,1.963,1.963,0,0,1-1.369-2.414l.094-.342a1.963,1.963,0,0,1,3.784,1.044l-.094.342h0a1.959,1.959,0,0,1-1.891,1.441Z",
    transform: "translate(-122.595 -82.389)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M263.806,163.526a1.847,1.847,0,0,1-.526-.076,1.961,1.961,0,0,1-1.371-2.414l.1-.342h0a1.963,1.963,0,0,1,3.78,1.047l-.094.342a1.965,1.965,0,0,1-1.888,1.441Z",
    transform: "translate(-119.498 -95.39)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M258.291,183.238a1.9,1.9,0,0,1-.526-.07,1.962,1.962,0,0,1-1.367-2.414l.094-.342a1.963,1.963,0,1,1,3.784,1.048l-.1.342h0a1.964,1.964,0,0,1-1.888,1.437Z",
    transform: "translate(-115.963 -107.987)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M253.523,203.287a1.962,1.962,0,0,1-1.892-2.484l.094-.342h0a1.962,1.962,0,0,1,3.783,1.044l-.094.342a1.963,1.963,0,0,1-1.892,1.439Z",
    transform: "translate(-112.907 -120.842)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M248.653,223.287a1.926,1.926,0,0,1-.521-.071,1.961,1.961,0,0,1-1.371-2.414l.107-.325a1.962,1.962,0,1,1,3.783,1.04l-.094.342a1.962,1.962,0,0,1-1.9,1.428Z",
    transform: "translate(-109.785 -133.648)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M151.675,50.406a1.9,1.9,0,0,1-.643-.107,1.961,1.961,0,0,1-1.208-2.5l.172-.5a1.962,1.962,0,0,1,3.689,1.271l-.157.5a1.964,1.964,0,0,1-1.853,1.334Z",
    transform: "translate(-47.604 -22.837)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M142.194,79.172a1.961,1.961,0,0,1-1.853-2.607l.172-.5h0a1.963,1.963,0,1,1,3.706,1.287l-.172.5h0a1.962,1.962,0,0,1-1.852,1.319Z",
    transform: "translate(-41.524 -41.117)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M132.7,108.557a1.958,1.958,0,0,1-1.852-2.606l.172-.5h0a1.963,1.963,0,0,1,3.709,1.287l-.177.5a1.963,1.963,0,0,1-1.853,1.318Z",
    transform: "translate(-35.44 -60.001)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M122.589,137.448a1.9,1.9,0,0,1-.643-.107,1.96,1.96,0,0,1-1.212-2.5l.177-.5a1.962,1.962,0,1,1,3.7,1.288l-.177.506a1.961,1.961,0,0,1-1.849,1.31Z",
    transform: "translate(-28.952 -78.483)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M244.827,115.6a1.968,1.968,0,0,1-.519-.07l-4.317-1.177a1.963,1.963,0,0,1,1.037-3.784l4.317,1.177a1.963,1.963,0,0,1-.519,3.854Z",
    transform: "translate(-104.602 -64.092)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M117.861,39.836a1.77,1.77,0,0,1-.5-.067l-7.456-1.962a1.962,1.962,0,0,1,1-3.79l7.456,1.962a1.962,1.962,0,0,1-.5,3.857Z",
    transform: "translate(-21.199 -15.015)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M106.964,35.692a1.963,1.963,0,0,1-1.892-2.481l1.177-4.317a1.963,1.963,0,0,1,3.784,1.037l-1.177,4.317a1.962,1.962,0,0,1-1.892,1.444Z",
    transform: "translate(-18.936 -10.871)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M106.6,70.375a1.77,1.77,0,0,1-.5-.067L98.64,68.346a1.962,1.962,0,1,1,1-3.79l7.456,1.962a1.962,1.962,0,0,1-.5,3.857Z",
    transform: "translate(-13.859 -34.565)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M96.025,66.1a1.963,1.963,0,0,1-1.892-2.481l1.177-4.317a1.963,1.963,0,1,1,3.784,1.037L97.918,64.66A1.962,1.962,0,0,1,96.025,66.1Z",
    transform: "translate(-11.922 -30.294)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M97.845,98.817a1.77,1.77,0,0,1-.5-.067L89.89,96.788a1.962,1.962,0,1,1,1-3.79l7.456,1.962a1.962,1.962,0,0,1-.5,3.857Z",
    transform: "translate(-8.248 -52.802)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M87.275,94.546a1.963,1.963,0,0,1-1.892-2.481l1.177-4.317a1.963,1.963,0,1,1,3.784,1.037L89.168,93.1a1.962,1.962,0,0,1-1.892,1.444Z",
    transform: "translate(-6.311 -48.53)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M88.005,129.437a1.771,1.771,0,0,1-.5-.067l-7.456-1.962a1.962,1.962,0,1,1,1-3.79L88.5,125.58a1.962,1.962,0,0,1-.5,3.857Z",
    transform: "translate(-1.939 -72.435)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M77.432,125.166a1.963,1.963,0,0,1-1.892-2.481l1.177-4.317a1.963,1.963,0,1,1,3.784,1.037l-1.177,4.317a1.962,1.962,0,0,1-1.892,1.444Z",
    transform: "translate(0 -68.164)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M239.357,135.291a1.968,1.968,0,0,1-.519-.07l-4.317-1.177a1.963,1.963,0,0,1,1.037-3.784l4.317,1.177a1.963,1.963,0,0,1-.519,3.854Z",
    transform: "translate(-101.094 -76.717)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M233.887,154.971a1.968,1.968,0,0,1-.519-.07l-4.317-1.177a1.963,1.963,0,0,1,1.037-3.784l4.317,1.177a1.963,1.963,0,0,1-.519,3.854Z",
    transform: "translate(-97.587 -89.336)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M228.417,174.661a1.968,1.968,0,0,1-.519-.07l-4.317-1.177a1.963,1.963,0,0,1,1.037-3.784l4.317,1.177a1.963,1.963,0,0,1-.519,3.854Z",
    transform: "translate(-94.08 -101.961)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M222.947,195.441a1.968,1.968,0,0,1-.519-.07l-4.317-1.177a1.963,1.963,0,0,1,1.037-3.784l4.317,1.177a1.963,1.963,0,0,1-.519,3.854Z",
    transform: "translate(-90.572 -115.285)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M217.477,215.131a1.968,1.968,0,0,1-.519-.07l-4.317-1.177a1.963,1.963,0,0,1,1.037-3.784L218,211.277a1.963,1.963,0,0,1-.519,3.854Z",
    transform: "translate(-87.065 -127.91)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M355.651,52.808a1.967,1.967,0,0,1-1.57-.785,25.437,25.437,0,0,1-5.176-15.482,25.666,25.666,0,1,1,51.329,0,24.639,24.639,0,0,1-5.019,15.238,1.962,1.962,0,1,1-3.14-2.355,20.8,20.8,0,0,0,4.215-12.868,21.742,21.742,0,1,0-43.479,0,21.528,21.528,0,0,0,4.4,13.119,1.962,1.962,0,0,1-1.57,3.14Z",
    transform: "translate(-175.322)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M394.625,209.73h-13.2a5.013,5.013,0,0,1-5.342-4.886l-6.408-62.673a1.962,1.962,0,0,1,3.9-.392l6.417,62.749a1.018,1.018,0,0,1,0,.185,1.207,1.207,0,0,0,1.421,1.095h13.2c1.06,0,1.648-.392,1.751-1.217a.412.412,0,0,1,0-.059l6.321-62.756a1.962,1.962,0,0,1,3.9.392l-6.31,62.724a5.341,5.341,0,0,1-5.659,4.84Z",
    transform: "translate(-188.633 -83.004)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M418.6,282.876a1.962,1.962,0,0,1-1.962-1.962v-.235a1.962,1.962,0,1,1,3.924,0v.235a1.962,1.962,0,0,1-1.962,1.962Z",
    transform: "translate(-218.755 -171.941)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M399.916,128.967H364.277c-2.285,0-4.073-2.15-4.073-4.895v-2.383c0-2.814,1.79-5.019,4.073-5.019h35.638c2.265,0,3.968,2.158,3.968,5.019v2.383C403.882,126.863,402.179,128.967,399.916,128.967Zm-35.525-3.925h35.351a1.881,1.881,0,0,0,.213-.97v-2.383h0a2.156,2.156,0,0,0-.252-1.095H364.438a1.787,1.787,0,0,0-.311,1.095v2.383h0a1.529,1.529,0,0,0,.264.97Z",
    transform: "translate(-182.568 -68.039)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M369.7,403.406a1.942,1.942,0,0,1-1.088-.329,1.963,1.963,0,0,1-.545-2.72c1.84-2.747,3.262-7.225,2.292-10.989a6.671,6.671,0,0,0-3.5-4.446c-3.14-1.62-7.064-.6-10.823.392-.785.2-1.57.392-2.355.589-5.248,1.225-11.193,2.61-17.24,2.006a19.363,19.363,0,0,1-10.356-4.09,12.32,12.32,0,0,1-4.709-10.372,10.818,10.818,0,0,1,4.391-8.606c5.337-3.894,14.3-3.347,20.357-1.7,1.55.423,3.168.981,4.875,1.57,6.279,2.17,12.8,4.419,17.512.7a7.258,7.258,0,0,0,1.57-10.016,32.4,32.4,0,0,0-5.368-5.778,37.162,37.162,0,0,1-5.942-6.46c-3.709-5.6-4.051-12.661-3.689-17.6a1.968,1.968,0,1,1,3.924.292c-.322,4.317-.05,10.47,3.041,15.144a32.825,32.825,0,0,0,5.346,5.749,36.1,36.1,0,0,1,5.981,6.5,11.211,11.211,0,0,1-2.422,15.262c-6.4,5.051-14.623,2.209-21.223-.07-1.648-.569-3.2-1.107-4.627-1.5-5.447-1.483-13.088-1.777-17.008,1.083a6.871,6.871,0,0,0-2.786,5.6c-.275,6.314,5.793,9.811,11.542,10.389,5.4.541,11.012-.765,15.957-1.923.726-.168,1.463-.362,2.245-.565,4.282-1.118,9.133-2.383,13.614-.074h0a10.6,10.6,0,0,1,5.494,6.951c1.118,4.317,0,9.878-2.826,14.128a1.962,1.962,0,0,1-1.629.879Z",
    transform: "translate(-157.661 -200.806)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M408.164,181.948a7.848,7.848,0,1,1,5.55-2.3A7.851,7.851,0,0,1,408.164,181.948Zm0-11.773a3.924,3.924,0,1,0,2.775,1.15,3.926,3.926,0,0,0-2.775-1.15Z",
    transform: "translate(-208.287 -99.829)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M461.677,68.214h-.345a1.962,1.962,0,1,1,0-3.925h.349a1.962,1.962,0,0,1,0,3.925Z",
    transform: "translate(-246.152 -34.453)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M461.677,101.147h-.345a1.962,1.962,0,1,1,0-3.925h.349a1.962,1.962,0,0,1,0,3.925Z",
    transform: "translate(-246.152 -55.569)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M431.73,35.284h-.349a1.962,1.962,0,1,1,0-3.925h.349a1.962,1.962,0,0,1,0,3.925Z",
    transform: "translate(-226.948 -13.339)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M431.73,68.214h-.349a1.962,1.962,0,1,1,0-3.925h.349a1.962,1.962,0,0,1,0,3.925Z",
    transform: "translate(-226.948 -34.453)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M431.73,101.147h-.349a1.962,1.962,0,1,1,0-3.925h.349a1.962,1.962,0,0,1,0,3.925Z",
    transform: "translate(-226.948 -55.569)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M401.777,35.284h-.35a1.962,1.962,0,1,1,0-3.925h.35a1.962,1.962,0,1,1,0,3.925Z",
    transform: "translate(-207.742 -13.339)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M401.777,68.214h-.35a1.962,1.962,0,1,1,0-3.925h.35a1.962,1.962,0,1,1,0,3.925Z",
    transform: "translate(-207.742 -34.453)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M401.777,101.147h-.35a1.962,1.962,0,1,1,0-3.925h.35a1.962,1.962,0,1,1,0,3.925Z",
    transform: "translate(-207.742 -55.569)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M371.83,68.214h-.349a1.962,1.962,0,0,1,0-3.925h.349a1.962,1.962,0,1,1,0,3.925Z",
    transform: "translate(-188.54 -34.453)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M371.83,101.147h-.349a1.962,1.962,0,0,1,0-3.925h.349a1.962,1.962,0,1,1,0,3.925Z",
    transform: "translate(-188.54 -55.569)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M268.875,307.547H252.093a1.962,1.962,0,1,1,0-3.925h16.782a1.962,1.962,0,1,1,0,3.925Z",
    transform: "translate(-111.991 -187.911)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M268.875,345.567H252.093a1.962,1.962,0,1,1,0-3.925h16.782a1.962,1.962,0,1,1,0,3.925Z",
    transform: "translate(-111.991 -212.289)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M268.875,383.587H252.093a1.962,1.962,0,1,1,0-3.925h16.782a1.962,1.962,0,1,1,0,3.925Z",
    transform: "translate(-111.991 -236.667)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M268.875,422.457H252.093a1.962,1.962,0,1,1,0-3.924h16.782a1.962,1.962,0,1,1,0,3.924Z",
    transform: "translate(-111.991 -261.59)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M268.875,460.477H252.093a1.962,1.962,0,1,1,0-3.925h16.782a1.962,1.962,0,1,1,0,3.925Z",
    transform: "translate(-111.991 -285.968)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M268.875,498.3H252.093a1.962,1.962,0,1,1,0-3.924h16.782a1.962,1.962,0,1,1,0,3.924Z",
    transform: "translate(-111.991 -310.218)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M132.155,240.827H115.373a1.962,1.962,0,1,1,0-3.924h16.782a1.962,1.962,0,0,1,0,3.924Z",
    transform: "translate(-24.327 -145.131)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M132.155,282.667H115.373a1.962,1.962,0,1,1,0-3.925h16.782a1.962,1.962,0,0,1,0,3.925Z",
    transform: "translate(-24.327 -171.958)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M132.155,324.507H115.373a1.962,1.962,0,1,1,0-3.925h16.782a1.962,1.962,0,0,1,0,3.925Z",
    transform: "translate(-24.327 -198.785)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M132.155,367.257H115.373a1.962,1.962,0,1,1,0-3.925h16.782a1.962,1.962,0,0,1,0,3.925Z",
    transform: "translate(-24.327 -226.196)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M132.155,409.1H115.373a1.962,1.962,0,1,1,0-3.925h16.782a1.962,1.962,0,0,1,0,3.925Z",
    transform: "translate(-24.327 -253.024)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M132.155,450.707H115.373a1.962,1.962,0,0,1,0-3.925h16.782a1.962,1.962,0,0,1,0,3.925Z",
    transform: "translate(-24.327 -279.704)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M132.155,492.827H115.373a1.962,1.962,0,1,1,0-3.925h16.782a1.962,1.962,0,0,1,0,3.925Z",
    transform: "translate(-24.327 -306.711)",
    fill: "#2b215e",
    stroke: "#2b215e",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineup);
export default __webpack_public_path__ + "static/media/lineup.0cef160b43b0f287dfd36b816b8ea1fb.svg";
export { ForwardRef as ReactComponent };